import { getCategoriesByCountry, getDealersByCountry } from '@yme/api';
import { actions } from '@yme/components/CheckoutForm/redux/actions';
import { getDealerWithCategoriesServices } from '@yme/utils/dealer';
import { getFilteredDataList, getDealersWithCoordinates } from './helpers';
export const getDealerLocatorService = ({ coordinates, country, language, dispatch, }) => {
    (async () => {
        const [dealers, categories] = await Promise.all([
            getDealersByCountry(country, language),
            getCategoriesByCountry({
                country,
            }),
        ]);
        const result = getDealerWithCategoriesServices(dealers, categories);
        const payload = coordinates
            ? getFilteredDataList(result, coordinates)
            : getDealersWithCoordinates(result);
        dispatch(actions.dealerList(payload));
    })();
};
